import styled from "styled-components";
import { themes } from "../../config/themes";

export const Outer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top:0;
  left:0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: column;
`;

export const LoginContainer = styled.div`
  height: auto;
  width: 500px;
  background: ${props => props.theme.grid_widget_bg};
  border: ${props => props.theme.login_border};
  box-sizing: border-box;
  box-shadow: ${props => props.theme.login_box_shadow};
  border-radius: ${props => props.theme.login_border_radius};
  
  @media(max-width: 500px) {
    width: 100%;
  }
`;
export const LoginLogo = styled.div`
  height: 30vh;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const LoginLogoText1 = styled.div`
  font-family: 'Open Sans', sans-serif;;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.06em;
  color: #3282F7;
  margin: 0px 1px
`
export const LoginLogoText2 = styled.div`
  font-family: 'Open Sans', sans-serif;;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: -0.06em;
  color: #FFFFFF;
  margin: 0 10px;
`